<template>
  <print-template :viewHeader="false" :viewFooter="false">
    <ul class="list-unstyled">
      <li v-for="(item, index) in items" :key="index">
        <svg :id="'PART_ID_' + item.part.id"></svg>
      </li>
    </ul>
  </print-template>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import BatchInfo from "@/models/BatchInfo";
import JsBarcode from "jsbarcode";
export default {
  name: "barcodePrint",
  components: { PrintTemplate },
  data() {
    return {
      batch: new BatchInfo(),
      items: []
    };
  },
  updated() {
    for (let item of this.items) {
      JsBarcode(`#PART_ID_${item.part.id}`, `${item.part.part_no}`, {
        format: "CODE39"
      });
    }
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      BatchInfo.fetch(this.$route.params.id).then(resp => {
        for (let item of resp.items) {
          this.items.push({
            ...item
          });
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
@media print {
  li {
    page-break-after: always;
  }
}
</style>
